module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-breadcrumbs-03d8594311439c05c61d3bc2f3454570.svg";